<template>
    <div :class="{'bind-course': showCourse == 1 }">
        <div v-if="showCourse == 2">
            <div class="accounts_area" v-if="accountList.length > 0">
                <div class="account-item" v-for="(item, i) in accountList" :key="i">
                    <i class="icon-alipay"></i>
                    <p class="name">{{ item.name }}</p>
                    <p class="account">{{ item.account | plusX }}</p>
                    <div class="modify" @click="modify(item)">修改</div>
                    <div class="unbind" @click="unbind(item)">解绑</div>
                </div>
            </div>
            <div class="add_account" @click="gotoBind('')"><i class="icon icon-plus"></i><span>添加支付宝提现</span></div>
        </div>
        <div v-if="showCourse == 1">
            <div class="step step1" v-if="step == 1">
                <img class="step-tit" src="../../assets/version_1.3.7/step1-tit.png" alt="">
                <p>打开支付宝进入&nbsp;<b>我的</b></p>
                <p>点击顶部账号&nbsp;<b>右侧箭头</b>进入个人信息</p>
                <img class="step-img" src="../../assets/version_1.3.7/step1.png" alt="">
                <div class="btns">
                    <van-button round color="var(--theme)" @click="step = 2">下一步</van-button>
                </div>
                <a class="skip" href="javascript:;" @click="gotoBind('')">我是老用户，跳过教程</a>
            </div>
            <div class="step step2" v-if="step == 2">
                <img class="step-tit" src="../../assets/version_1.3.7/step2-tit.png" alt="">
                <p>点击&nbsp;<b>我的主页</b></p>
                <img class="step-img" src="../../assets/version_1.3.7/step2.png" alt="">
                <div class="btns">
                    <van-button round plain color="#A4A4A4" @click="step = 1">上一步</van-button>
                    <van-button round color="var(--theme)" @click="step = 3">下一步</van-button>
                </div>
                <a class="skip" href="javascript:;" @click="gotoBind('')">我是老用户，跳过教程</a>
            </div>
            <div class="step step3" v-if="step == 3">
                <img class="step-tit" src="../../assets/version_1.3.7/step3-tit.png" alt="">
                <p>按图例手机全屏截图，上传完成绑定></p>
                <img class="step-img" src="../../assets/version_1.3.7/step3.png" alt="">
                <div class="btns">
                    <van-button round color="var(--theme)" @click="gotoBind('')">上传截图</van-button>
                </div>
                <a class="skip" href="javascript:;" @click="gotoBind('')">我是老用户，跳过教程</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            bindData: {
                name: "",
                account: "",
            },
            is_bind: false,
            showBind: false,
            accountList: [],
            showCourse: 0,//1:教程  2:账号列表
            step: 1
        };
    },
    filters: {
        plusX(str) {
            var x = "****";
            if (str.length >= 6) {
                return (
                    str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
                );
            } else {
                return str;
            }
        },
    },
    created() {
        this.checkAccountInfo();
    },
    beforeDestroy() {
        this.$store.commit('clearPageTitleOverride')
    },
    methods: {
        //查询收款账户
        async checkAccountInfo() {
            await this.$Ajax("wallet/recv-account-info", {}, "get").then(rs => {
                this.showBind = true;
                if (rs.code == 200) {
                    this.accountList = rs.data;
                    if (this.showCourse === 0) {
                        if (rs.data.length == 0) {
                            this.showCourse = 1
                            this.$store.commit('setPageTitleOverride', { title: '绑定教程', routeName: this.$route.name })
                        } else {
                            this.showCourse = 2
                            this.$store.commit('setPageTitleOverride', { title: '账号管理', routeName: this.$route.name })
                        }
                    }
                }
            });
        },
        //前往绑定账号
        gotoBind(action) {
            if (action) {
                this.$router.push({
                    name: "bind.account",
                    query: {
                        action,
                    },
                });
            } else {
                this.$router.push({
                    name: "bind.account",
                });
            }
        },
        //解绑收款账户弹框
        unbind(item) {
            var that = this;
            this.$RModal.unbindalipay({
                noheader: true,
                onSuccess: () => {
                    that.$Ajax("wallet/delete-ali-acc", {
                        id: item.id,
                    }, "post").then(rs => {
                        if (rs.code == 200) {
                            that.$toast("解绑成功");
                            that.checkAccountInfo();
                        }
                    });
                }
            })
        },
        modify(item) {
            this.$router.push({
                name: "bind.account",
                query: {
                    action: 'modify',
                    id: item.id,
                },
            });
        }
    }
};
</script>
<style lang="less" scoped>
.box-item {
    background-color: #fff;
    display: flex;
    align-items: center;
    height: 3.6rem;
    padding: 0 1.6rem;
    border-radius: 0.6rem;
    font-size: 1.4rem;

    img {
        width: 1.85rem;
        height: 1.85rem;
        margin-right: 0.6rem;
    }

    .prefix {
        width: 6.8rem;
    }

    /deep/.amount_ipt {
        flex: 1;

        .el-input__inner {
            width: 100%;
            padding: 0;
            border: none;
        }
    }
}

.bind_alipay {
    border-radius: 0.6rem;
    overflow: hidden;
    background-color: #fff;
    margin: 1.2rem 0;

    .ba_item {
        height: 4.4rem;
        display: flex;
        align-items: center;
        padding: 0 1.6rem;
        color: #000;
        font-size: 1.4rem;

        .prefix {
            width: 6.8rem;
        }
    }
}

.modify_btn {
    background-color: var(--confirm);
    height: 3.2rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10rem;
    font-size: 1.4rem;
    margin-top: 4rem;

    &:active {
        opacity: 0.9;
    }
}

.gotobind {
    height: 3rem;
    border-radius: 10rem;
    width: 12rem;
    font-size: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4rem auto 0;
}


.accounts_area {
    padding: 1.2rem 0 0;

    .account-item {
        display: flex;
        align-items: center;
        padding: 2rem 1rem 1.4rem;
        margin-bottom: 1rem;
        background-color: #fff;
        border-radius: 1rem;
        position: relative;

        .icon-alipay {
            width: 2rem;
            height: 2rem;
            background: url(../../assets/bx/alipay.png) no-repeat 0 0;
            background-size: 100% 100%;
            margin-right: 1.2rem;
        }

        .name {
            font-size: 1.6rem;
            color: #000;
            margin-right: 1rem;
            max-width: 30%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .account {
            font-size: 1.6rem;
            color: #a4a4a4;
        }

        .unbind {
            font-size: 1.6rem;
            color: #a4a4a4;
            position: absolute;
            right: 1rem;
            top: 1.8rem;
            cursor: pointer;

            &:hover {
                color: var(--theme);
            }
        }

        .modify {
            font-size: 1.6rem;
            color: #a4a4a4;
            position: absolute;
            right: 5.5rem;
            top: 1.8rem;
            cursor: pointer;

            &:hover {
                color: var(--theme);
            }
        }
    }
}

.add_account {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1.6rem 1rem;
    font-size: 1.6rem;
    color: #a4a4a4;
    background-color: #fff;
    border-radius: 1rem;
    cursor: pointer;

    .icon-plus {
        width: 2rem;
        height: 2rem;
        background: url(../../assets/bx/add.png) no-repeat 0 0;
        background-size: 100% 100%;
        margin-right: 1rem;
    }
}

.bind-course {
    height: calc(var(--vh, 1vh)*100 - 5rem + .5rem);
    background: linear-gradient(180deg, #FDFAE7 0%, #FEFBE8 100%);
    border-radius: .5rem .5rem 0px 0px;
    z-index: 1000;
    position: relative;
    margin-top: -.5rem;
    overflow-x: hidden;
    overflow-y: auto;
}

.step {
    padding-top: 1.8rem;
    padding-bottom: 5rem;

    .step-tit {
        width: 13rem;
        height: auto;
        margin-left: 2.7rem;
        margin-bottom: 1.7rem;
    }

    p {
        margin-left: 2.7rem;
        font-size: 1.4rem;
        color: #010102;
    }

    .step-img {
        max-width: 100%;
        height: auto;
        margin: 0 auto;
        display: block;
    }

    .btns {
        display: flex;
        justify-content: center;
        margin-bottom: 3rem;

        .van-button {
            width: 25rem;
            height: 4rem;
            font-size: 1.6rem;

            &:not(:last-child) {
                margin-right: 1rem;
            }

            &.van-button--plain {
                background-color: transparent;
            }
        }
    }

    .skip {
        display: table;
        margin: 0 auto;
        font-size: 1.4rem;
        color: #A4A4A4;
    }

    &.step1 {
        .step-img {
            margin-top: .6rem;
            margin-bottom: .3rem;
        }
    }

    &.step2 {
        .step-img {
            margin-top: 4.2rem;
            margin-bottom: 1.6rem;
        }

        .btns {
            .van-button {
                width: 15rem;
            }
        }
    }

    &.step3 {
        .step-img {
            width: 20.2rem;
            margin-top: 4.6rem;
            margin-bottom: 3.4rem;
        }
    }
}
</style>
